export default __webpack_public_path__ + "static/media/game-level-complete-143022.f65684e8.mp3";